import { NoResult } from 'ui/illustrations';
import { Link } from 'ui/links';
import { EmptyContainer, EmptyImage, EmptyInfoContent, EmptyInfoSubText } from './Styled';

export const ConversionsEmptyCard = () => {
  return (
    <EmptyContainer data-testid="conversion-metric-empty-state">
      <EmptyImage>
        <NoResult />
      </EmptyImage>
      <EmptyInfoContent>Looks like you don’t have any conversion metrics</EmptyInfoContent>
      <EmptyInfoSubText>
        {`Learn how to use conversions in your next campaign by visiting our `}
        <Link
          hasOpenNewTabIcon
          href="https://support.iterable.com/hc/en-us/articles/204780559-Tracking-Custom-Conversions-"
          target="_blank"
        >
          Knowledge Center
        </Link>
        .
      </EmptyInfoSubText>
    </EmptyContainer>
  );
};
